import styled from 'styled-components';

const Loader = styled.div`
  width: ${props => props.inline ? 'auto' : '100%'};
  height: 100%;
  min-height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
const Text = styled.div`
  font-family: "Montserrat", sans-serif;
  font-size: 15px;
`;
// <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
function LoadingAnim(props) {
  return (
    <Loader id="snitch" inline={props.inline}>
      <img src="/wp-content/themes/wbstt-modular-theme/assets/images/snitch_dark.gif"/>
      {props.text && <Text>{props.text}</Text>}
    </Loader>
  );
}
export default LoadingAnim;
